import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const calendarApi = createApi({
  reducerPath: "calendarApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/api" }),
  tagTypes: ["Calendar"],
  endpoints: (b) => ({
    getCustomEventsRange: b.query<any, { start: string; end: string }>({
      query: ({ start, end }) => ({
        url: `customevents/`,
        params: { timelineStart: start, timelineEnd: end },
      }),
    }),
    getBookingEventsRange: b.query<
      { startEvents: any[]; endEvents: any[] },
      { start: string; end: string }
    >({
      query: ({ start, end }) => ({
        url: `bookingsevents/`,
        params: { timelineStart: start, timelineEnd: end },
      }),
      transformResponse: (response: any) => ({
        startEvents: response?.[0] ?? [],
        endEvents: response?.[1] ?? [],
      }),
    }),
  }),
});

export const {
  useGetCustomEventsRangeQuery,
  useLazyGetCustomEventsRangeQuery,
  useGetBookingEventsRangeQuery,
  useLazyGetBookingEventsRangeQuery,
} = calendarApi;

